import { useEffect, useState } from 'react';

/** A T-minus breakdown to a target time. */
export interface Countdown {
  h: number;
  m: number;
  s: number;
  /** True once the target time has passed. */
  past: boolean;
}

/** Live T-minus countdown to an ISO target, ticking once per second. */
export function useCountdown(targetIso: string | undefined): Countdown {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = setInterval(() => setNow(Date.now()), 1000);
    return () => clearInterval(id);
  }, []);

  const target = targetIso ? new Date(targetIso).getTime() : Number.NaN;
  const remaining = Number.isFinite(target) ? target - now : 0;
  const clamped = Math.max(remaining, 0);
  return {
    h: Math.floor(clamped / 3_600_000),
    m: Math.floor((clamped % 3_600_000) / 60_000),
    s: Math.floor((clamped % 60_000) / 1000),
    past: remaining <= 0,
  };
}
